// Vue-Directive ruf gegebene callback, wenn das mitgelieferte Argument <true> ist.
// Und wenn click.target nicht auf dem Element oder Kindern ist

// REQUIRED: callback, die das Element schließt
// REQUIRED: modifier, isVisible wert des Elements <boolean>

import { createCallback } from './helpers';

export default {
  inserted(el, binding) {
    if (el.onBlur) return;
    const callback = createCallback(el, binding.value);
    const options = binding.options || { passive: false };

    // setTimeout um eventuell das Klicken des "triggers" abzuwarten
    // sonst callback 2x ausgeführt, wenn "trigger geclickt wird" => open->close
    setTimeout(() => {
      const isVisible = binding.arg;
      if (isVisible) {
        window.addEventListener('click', callback, options);
        window.addEventListener('touch', callback, options);
        window.addEventListener('touchstart', callback, options);
      }
    }, 0);

    el.onBlur = {  // eslint-disable-line
      options,
      callback,
    };
  },

  update: (el, binding) => {
    const { callback, options } = el.onBlur;
    // setTimeout um eventuell das Klicken des "triggers" abzuwarten
    // sonst callback 2x ausgeführt, wenn "trigger geclickt wird" => open->close
    setTimeout(() => {
      const isVisible = binding.arg;

      if (isVisible) {
        window.addEventListener('click', callback, options);
        window.addEventListener('touch', callback, options);
        window.addEventListener('touchstart', callback, options);
      } else {
        window.removeEventListener('click', callback, options);
        window.removeEventListener('touch', callback, options);
        window.addEventListener('touchstart', callback, options);
      }
    }, 0);
  },

  unbind: (el) => {
    if (!el.onBlur) return;
    const { options, callback } = el.onBlur;
    window.removeEventListener('click', callback, options);
    window.removeEventListener('touch', callback, options);
    delete el.onBlur; // eslint-disable-line
  },
};
